module.exports = __webpack_public_path__ + "static/img/atlasGif2.c0769687.gif";